/* Hokuō, siste sjanse.
   Kjøpsknappene legger varen i handlekurven uten sideskifte og åpner handlekurv-skuffen i temaet.
   Uten JavaScript sendes skjemaet på vanlig måte til /cart/add. */
(function () {
  'use strict';
  if (window.LsHk) return;
  window.LsHk = true;

  function initBuy(form) {
    if (form.__hkBuy) return;
    form.__hkBuy = true;
    var btn = form.querySelector('[data-hk-cta]');
    var box = form.closest('[data-hk-box]');
    var err = box ? box.querySelector('[data-hk-err]') : null;
    var busy = false;

    function showErr(text) {
      if (!err) return;
      err.textContent = text || '';
      err.hidden = !text;
    }

    form.addEventListener('submit', function (e) {
      var routes = window.theme && window.theme.routes;
      if (!routes || !routes.cartAdd || !window.fetch || !window.FormData) return; // reserve: vanlig innsending
      e.preventDefault();
      if (busy) return;
      busy = true;
      showErr('');
      if (btn) btn.setAttribute('aria-busy', 'true');

      fetch(routes.cartAdd, { method: 'POST', body: new FormData(form), headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (res) {
          return res.json().then(function (data) { return { ok: res.ok, data: data }; });
        })
        .then(function (r) {
          if (!r.ok || (r.data && (r.data.status || r.data.description))) {
            var d = r.data && r.data.description;
            var er = new Error(typeof d === 'string' ? d : '');
            er.hkText = true; // meldingen kommer fra butikken og kan vises som den er
            throw er;
          }
          if (window.theme && window.theme.settings && window.theme.settings.cartType === 'page') {
            window.location = routes.cartPage || '/cart';
            return;
          }
          form.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: r.data, addToCartBtn: btn }, bubbles: true }));
        })
        .catch(function (x) {
          showErr((x && x.hkText && x.message) || (box && box.getAttribute('data-hk-error')) || '');
        })
        .then(function () {
          busy = false;
          if (btn) btn.removeAttribute('aria-busy');
        });
    });
  }

  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;
    Array.prototype.forEach.call(scope.querySelectorAll('form[data-hk-buy]'), initBuy);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(document); });
  else scan(document);
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();